import * as React from 'react'
import PropTypes from 'prop-types'
import { generatePath, Link } from 'react-router-dom'

import { useBreakpoints } from 'hooks'
import { constants } from 'helpers'
import { EventCardBig, EventCardSmall } from 'components/EventCard'
import { SwiperSlide, SwiperWithTitle } from 'components/Discover/SwiperWithTitle'
import CallToAction from './CallToAction'
import EmptyState from './EmptyState'
import MoreOptions from './MoreOptions'

const { ROUTES } = constants

const DashboardSection = ({
  events,
  user,
  isLoading,
  emptyState,
  onEnterEvent,
  onDiscoverEventsClick,
  onFilter,
}) => {
  const { lg } = useBreakpoints()
  const isAuthenticated = !!user

  return (
    <div>
      <div className="p-6 md:p-10">
        <div className="font-bold text-2xl text-white mb-5 md:mb-8">
          ATTENDING <span className="text-gray-500" />
        </div>
        {events?.length > 0 && (
          <>
            {lg ? (
              events.map(event => (
                <div key={event.id} className="relative mb-8" data-ticketeventid={event.id}>
                  <EventCardBig
                    key={event.id}
                    {...event}
                    isAuthenticated={isAuthenticated}
                    hideTags={true}
                    footer={<CallToAction event={event} onEnterEvent={onEnterEvent} lg={lg} />}
                  />
                  <MoreOptions />
                </div>
              ))
            ) : (
              <SwiperWithTitle title={''} className="border-t-0 border-none -mt-14">
                {events.map(event => (
                  <SwiperSlide
                    key={event.id}
                    className="flex-grow w-11/12 max-w-xs pt-5 h-auto lg:max-w-5xl"
                    data-ticketeventid={event.id}
                  >
                    {({ isPrev, isActive, isNext, isVisible }) =>
                      (isPrev || isActive || isNext || isVisible) && (
                        <Link
                          className="block relative h-full"
                          to={{
                            pathname: generatePath(ROUTES.EVENT, { event_id: event.slug }),
                          }}
                        >
                          <EventCardSmall
                            {...event}
                            isAuthenticated={isAuthenticated}
                            hideTags={true}
                            footer={
                              <CallToAction event={event} onEnterEvent={onEnterEvent} lg={lg} />
                            }
                          />
                          <MoreOptions />
                        </Link>
                      )
                    }
                  </SwiperSlide>
                ))}
              </SwiperWithTitle>
            )}
          </>
        )}
        {!isLoading && events?.length === 0 && (
          <EmptyState
            {...emptyState}
            onFilter={onFilter}
            onDiscoverEventsClick={onDiscoverEventsClick}
          />
        )}
      </div>
    </div>
  )
}

DashboardSection.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
  events: PropTypes.array,
  isLoading: PropTypes.bool,
  emptyState: PropTypes.shape({
    text: PropTypes.string,
    cta: PropTypes.string,
  }),
  onEnterEvent: PropTypes.func,
  onDiscoverEventsClick: PropTypes.func,
  onFilter: PropTypes.func,
}

export default DashboardSection
